import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Cell } from 'sarsaparilla';
import { VehicleTypes } from '../constants';
import { PassTypeProps, VehicleInfoProps } from '../props';
import { TextInput, SelectInput } from '../../../ui-lottery/src/components/inputs';

const propTypes = {
  vehicleInfo: VehicleInfoProps.isRequired,
  passType: PassTypeProps.isRequired,
  onChange: PropTypes.func.isRequired
};

export default class VehicleInfoForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      vehicleType: this.props.vehicleInfo.vehicle_type,
      licenseNumber: this.props.vehicleInfo.license_number
    };

    this.state.vehicleTypeIsValid = !this.validateVehicleType(this.props.vehicleInfo.vehicle_type);
    this.state.licenseNumberIsValid = !this.validateLicenseNumber(this.props.vehicleInfo.license_number);

    this.onVehicleTypeChanged = this.onVehicleTypeChanged.bind(this);
    this.onLicenseNumberChanged = this.onLicenseNumberChanged.bind(this);

    this.validateVehicleType = this.validateVehicleType.bind(this);
    this.validateLicenseNumber = this.validateLicenseNumber.bind(this);
  }

  componentDidMount() {
    this.props.onChange(this.props.vehicleInfo, this.formIsValid());
  }

  componentWillUnmount() {
    this.props.onChange(this.props.vehicleInfo, true);
  }

  onVehicleTypeChanged(vehicleType, vehicleTypeIsValid) {
    const { vehicleInfo } = this.props;

    this.setState((prevState) => ({ ...prevState, vehicleType, vehicleTypeIsValid }), () => {
      this.props.onChange({ ...vehicleInfo, vehicle_type: vehicleType }, this.formIsValid());
    });
  }

  onLicenseNumberChanged(licenseNumber, licenseNumberIsValid) {
    const { vehicleInfo } = this.props;

    this.setState((prevState) => ({ ...prevState, licenseNumber, licenseNumberIsValid }), () => {
      this.props.onChange({ ...vehicleInfo, license_number: licenseNumber }, this.formIsValid());
    });
  }

  validateVehicleType(value) {
    return value === '' && 'Please choose a vehicle type';
  }

  validateLicenseNumber(value) {
    const { vehicleType } = this.state;

    return this.isMissingLicenseNumber(value, vehicleType) && 'Please provide a license plate number';
  }

  isMissingLicenseNumber(number, type) {
    if (type !== 'personal-vehicle') {
      return false;
    }

    return number === '';
  }

  formIsValid() {
    const { vehicleType, licenseNumber } = this.state;

    return this.state.vehicleTypeIsValid
      && this.state.licenseNumberIsValid
      && !this.isMissingLicenseNumber(licenseNumber, vehicleType);
  }

  render() {
    const { passType, vehicleInfo } = this.props;

    if (passType.features.indexOf('vehicle-info') === -1) {
      return null;
    }

    const isValid = vehicleInfo.vehicle_type !== 'personal-vehicle' || vehicleInfo.license_number !== '';

    return (
      <Row>
        <Cell width={6}>
          <SelectInput
            label="Vehicle Type"
            id={'vehicle-type'}
            value={vehicleInfo.vehicle_type}
            options={Object.entries(VehicleTypes).map(([value, label]) => ({ label, value }))}
            onChange={this.onVehicleTypeChanged} />
        </Cell>
        <Cell width={6}>
          <TextInput
            label="License Plate Number"
            id={'vehicle-license'}
            value={vehicleInfo.license_number}
            isValid={isValid}
            validator={this.validateLicenseNumber}
            onChange={this.onLicenseNumberChanged} />
        </Cell>
      </Row>
    );
  }
}

VehicleInfoForm.propTypes = propTypes;
